export default __webpack_public_path__ + "static/media/rating_4.d18b37c7.png";